import React from 'react';
import { Car, TrendingUp, DollarSign, CheckCircle, Clock, Shield } from 'lucide-react';
export const CoreProducts = () => {
  const products = [{
    title: 'Fast Cash Logbook Loan',
    description: 'Up to 70% Value in 6 Hours',
    features: ['Quick approval process', 'Keep using your vehicle', 'Flexible repayment terms', 'No hidden charges'],
    icon: <Car size={32} className="text-primary-600" data-id="element-551" />,
    image: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    badge: '6 Hours'
  }, {
    title: 'Secured Business Loan',
    description: 'Boost Your Working Capital, Secured by Your Car',
    features: ['Competitive interest rates', 'Up to 5 years repayment', 'Business growth support', 'Dedicated account manager'],
    icon: <TrendingUp size={32} className="text-primary-600" data-id="element-552" />,
    image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    badge: 'Business'
  }, {
    title: 'Car & Asset Financing',
    description: 'Drive Away Today. Flexible Repayments.',
    features: ['New & used vehicles', 'Competitive rates from 12%', 'Up to 4 years to repay', 'Minimal documentation'],
    icon: <DollarSign size={32} className="text-primary-600" data-id="element-553" />,
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    badge: 'Finance'
  }, {
    title: 'Contractors Corner',
    description: 'Bid Bonds & Performance Bonds for Contractors',
    features: ['1-hour bid bond approval', 'Performance bonds available', 'Minimal collateral required', 'Government tender support'],
    icon: <Shield size={32} className="text-primary-600" data-id="element-554" />,
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    badge: 'Contractors',
    link: '#trade-finance'
  }];
  return <section id="core-products" className="py-20 bg-white" data-id="element-555">
      <div className="container" data-id="element-556">
        <div className="text-center mb-16" data-id="element-557">
          <h2 className="section-title" data-id="element-558">
            Our Live Solutions: Quick, Secured, Flexible
          </h2>
          <p className="section-subtitle" data-id="element-559">
            Fast, transparent financing solutions designed to meet your
            immediate needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-560">
          {products.map((product, index) => <div key={index} className="group bg-white rounded-2xl overflow-hidden border-2 border-gray-200 hover:border-primary-500 hover:shadow-2xl transition-all duration-300 card-hover" data-id="element-561">
              <div className="relative h-48 overflow-hidden" data-id="element-562">
                <img src={product.image} alt={product.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-563" />
                <div className="absolute top-4 right-4 bg-primary-600 text-white px-4 py-2 rounded-full text-sm font-bold flex items-center gap-2" data-id="element-564">
                  <Clock size={16} data-id="element-565" />
                  {product.badge}
                </div>
              </div>

              <div className="p-6" data-id="element-566">
                <div className="mb-4 w-14 h-14 bg-primary-50 rounded-xl flex items-center justify-center" data-id="element-567">
                  {product.icon}
                </div>

                <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-568">
                  {product.title}
                </h3>
                <p className="text-primary-600 font-semibold mb-4 text-sm" data-id="element-569">
                  {product.description}
                </p>

                <ul className="space-y-2 mb-6" data-id="element-570">
                  {product.features.map((feature, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-571">
                      <CheckCircle size={16} className="text-primary-600 flex-shrink-0 mt-0.5" data-id="element-572" />
                      <span className="text-gray-700 text-xs" data-id="element-573">{feature}</span>
                    </li>)}
                </ul>

                <a href={product.link || '/apply'} className="block text-center py-3 px-6 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl text-sm" data-id="element-574">
                  {product.link ? 'Learn More' : 'Apply Now'}
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};